/** @module csi/widget/NumberTextBox */
define([
	"csi/locale",
	"dojo/_base/declare",
	"csi/types",
	"csi/utility/numberUtility",
	"dijit/form/_TextBoxMixin",
	"dijit/form/NumberTextBox",
	"./_ErrorMessageMixin"
], function(locale,declare,types,numberUtility,_TextBoxMixin,NumberTextBox,_ErrorMessageMixin) {

	return declare([NumberTextBox, _ErrorMessageMixin], {
		/**
		 * Select text in text box
		 */
		selectAllText: function() {
			if (!this.disabled && !this.readOnly) {
				_TextBoxMixin.selectInputText(this.textbox);
			}
		},

		/**
		 * Select text when focused by tabbing into text box
		 * @param {string} [by]
		 */
		_onFocus: function(by) {
			this.inherited(arguments);

			if ((by != 'mouse') && !this._isTextSelected()) {
				this.selectAllText();
			}
		},

		/**
		 * @override
		 * Need to overwrite in order to use our own localization methods
		 * @param {Number} value 
		 * @param {Object} constraints 
		 * @returns {string}
		 */
		format: function(value, constraints){
			return numberUtility.formatNumber(value, constraints.pattern);
		},

		/**
		 * @override
		 * Need to overwrite in order to use our own localization methods
		 */
		isValid: function() {
			const { constraints } = this;
			// if textbox is empty, this.textbox.value has an empty value, and we use inherited validation.  Otherwise
			// use this.get('value').
			if (this._isEmpty(this.textbox.value)) {
				return this.inherited(arguments);
			} else {
				const value = this.get('value');
				if (typeof value !== 'number') {
					return false;
				}
				if (constraints) {
					if (constraints.max !== undefined && constraints.max < this.value) {
						return false;
					}
					if (constraints.min !== undefined && constraints.min > this.value) {
						return false;
					}
				}
				return true;
			}
		},

		/**
		 * @override
		 * Need to overwrite in order to use our own localization methods
		 * @param {string} value 
		 * @param {Object} constraints 
		 * @returns {string}
		 */
		parse: function(value, constraints){
			/** if format starts with currency symbols, we need to chop them off when parsing. */
			const format = constraints?.pattern;
			if (format) {
				const firstDigitIndex = format.search(/[\d#]/);
				const substring = format.substring(0,firstDigitIndex);
				if (value.startsWith(substring)) {
					value = value.substring(substring.length);
				}
			}
			return types.getInternalNumber(value);
		},

		/**
		 * Casting to Number ensures the initial conversion works properly if the value is a number
		 * if the value is a number and dealt with as string, the value will get set to undefined in the super class
		 * @param {string|number} value
		 * @param {Boolean} priorityChange
		 * @param {String} formattedValue
		 */
		_setValueAttr: function(value, priorityChange, formattedValue) {
			if (value != "" && !isNaN(value)) {
				value = Number(value);
			}

			this.inherited(arguments, [value, priorityChange, formattedValue]);
		}
	});
});
